const serviceWorkerReloadKey = "webconsole-service-worker-unregistered";

export default function register() {
  unregister();
}

export async function unregister() {
  if (!("serviceWorker" in navigator)) {
    return;
  }

  window.addEventListener("load", async () => {
    const hadController = Boolean(navigator.serviceWorker.controller);

    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map(registration => registration.unregister()));

      if ("caches" in window) {
        const cacheKeys = await caches.keys();
        await Promise.all(cacheKeys.map(cacheKey => caches.delete(cacheKey)));
      }

      if (hadController && !window.sessionStorage.getItem(serviceWorkerReloadKey)) {
        window.sessionStorage.setItem(serviceWorkerReloadKey, "1");
        window.location.reload();
        return;
      }

      window.sessionStorage.removeItem(serviceWorkerReloadKey);
    } catch (error) {
      console.error("Failed to unregister service workers:", error);
    }
  });
}
